import { z } from "zod"

export const organizationPublicSettingsSchema = z.object({
  slug: z
    .string()
    .min(3, "Slug must be at least 3 characters")
    .max(255, "Slug must be 255 characters or less")
    .regex(
      /^[a-z0-9]+(-[a-z0-9]+)*$/,
      "Slug can only contain lowercase letters, numbers, and hyphens"
    ),
  isPublic: z.boolean(),
  publicDescription: z
    .string()
    .max(500, "Public description must be 500 characters or less")
    .nullable(),
  publicContactEmail: z
    .string()
    .email("Must be a valid email")
    .or(z.literal(""))
    .nullable(),
})

export type OrganizationPublicSettingsFormData = z.infer<
  typeof organizationPublicSettingsSchema
>
